import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { isSemanticSearchModuleEnabled } from '../../app/helpers/semanticSearchConfigHelper';

/**
 * Badge de similitud en cards end-user.
 * Solo visible si el flag del módulo está ON y el ítem trae similarity_percent (path híbrido).
 */
const SemanticSimilarityBadge = ({ data, moduleKey }) => {
  const { t } = useTranslation();
  const configuration = useSelector((state) => state.configuration);

  if (!moduleKey || !isSemanticSearchModuleEnabled(configuration, moduleKey)) {
    return null;
  }

  const percentRaw = data?.similarity_percent;
  if (percentRaw === undefined || percentRaw === null || percentRaw === '') {
    return null;
  }

  const percent = Number(percentRaw);
  if (!Number.isFinite(percent)) {
    return null;
  }

  return (
    <span
      className="semantic-similarity-badge"
      title={t('semanticSearch.similarityTitle')}
    >
      {t('semanticSearch.similarityPercent', { percent: Math.round(percent) })}
    </span>
  );
};

export default SemanticSimilarityBadge;
